import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { McpConnectionRow } from "../mcpConnectionsViewConfig";
import { connectionPermissions } from "../mcpConnectionHelpers";

export const ConnectionPermissionsCell = memo(
    ({ row }: CellContext<ViewTableFeatures, McpConnectionRow, string>) => (
        <ViewTableCell>
            {connectionPermissions(row.original.scopes)}
        </ViewTableCell>
    ),
);
